const BP_METHODS={
  normal: 'Manual',
  bp_cuff: 'Bluetooth Cuff',
  bp_ai: 'Face Scan',
}

export default BP_METHODS;